import React, { useState, useEffect, useContext } from "react";
import Helmet from "react-helmet";

import CommonHeader from "../../../../components/Common/Header";

import History from "./History";
import Points from "./Points";
import { GlobalContext } from "../../../../context/GlobalContext";

const Rewards = ({ subSection, changeSubSection }) => {
  const context = useContext(GlobalContext);
  const user = context.user || {};

  const { pointsWithExpires, userGroup, firstName, lastName, points, ref } =
    user || "";

  const referralCode = (ref && ref.refCode) || "";
  const [activeSection, setActiveSection] = useState(subSection || "points");
  useEffect(() => {
    if (subSection && activeSection !== subSection) {
      setActiveSection(subSection);
    }
  }, [subSection]);

  return (
    <>
      <Helmet>
        <title>Rewards</title>
        <meta property="og:title" content="Rewards" />
      </Helmet>
      <div className="rewards-page">
        <CommonHeader active="rewards" />
        <div className="check-out mb-1 visible-xs">
          <div className="d-flex justify-content-between">
            <a href="javascript:void(0)">Rewards</a>
          </div>
        </div>
        {user.uid && (
          <div className="tab d-flex align-items-center justify-content-between">
            {/* şimdilik okay fakat, 2 fonksiyon olmamalı, başka bir yöntem bulunmalı, useEffect'i araştır. */}
            <button
              className={activeSection === "points" ? "active" : ""}
              onClick={() => {
                setActiveSection("points");
                if (changeSubSection) changeSubSection("points");
              }}
            >
              eCoins
            </button>
            <button
              className={activeSection === "history" ? "active" : ""}
              onClick={() => {
                setActiveSection("history");
                if (changeSubSection) changeSubSection("history");
              }}
            >
              History
            </button>
          </div>
        )}

        <div>
          {activeSection === "points" && (
            <Points
              userGroup={userGroup}
              firstName={firstName}
              lastName={lastName}
              points={points}
              referralCode={referralCode}
            />
          )}
          {activeSection === "history" && (
            <History pointsWithExpires={pointsWithExpires} />
          )}
        </div>
      </div>
    </>
  );
};

export default Rewards;
